import { render, staticRenderFns } from "./DescuentoComponent.vue?vue&type=template&id=508c28fb"
import script from "./DescuentoComponent.vue?vue&type=script&lang=js"
export * from "./DescuentoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports